export default __webpack_public_path__ + "assets/qr-code-advantages-reduce-payroll-cost.f45a166a.svg";